export const NEED_CHECK = 'needCheck';
export const INCOMPATIBLE = 'incompatible';
export const NEED_REQUIRED_PARTS = 'needRequiredParts';
export const COOKIE_HYPERDRIVE_SELECTED_UNIT = 'hyperdrive-selected-unit';
export const COOKIE_COOKIE_HYPERDRIVE_SELECTED_UNIT_EXPIRE = 30;
